import { ClockCircleFilled, CloseCircleOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons'
import { useState } from 'react'

import moment from 'moment';
import { SCHEDULE_STATUS } from '../../../../../common/constants/postsConstants';
import { ScheduledDateEdit } from './ScheduledDateEdit';

export const ScheduledDate = (props: { postScheduled: any, onChange: any}) => {

    const [edit, setEdit] = useState(false);
    const [editVisible, setEditVisible] = useState(false);    

    const handleMouseEnter = () => {
        setEditVisible(true);
    };

    const handleMouseLeave = () => {
        setEditVisible(false);
    };
      
    return (
        <div  
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{backgroundColor: edit ? 'ivory' : editVisible ? 'ivory' : '', marginBottom: '10px', display:'flex', alignItems: 'center', padding:'5px 10px'}}>                    
   
            {
                !edit ?
                    <span style={{color: SCHEDULE_STATUS[props.postScheduled.status].color, fontSize: '17px'}}> <strong><ClockCircleFilled/> {moment(props.postScheduled.post.scheduleDate).format('ll')}</strong></span>
                :                         
                    <ScheduledDateEdit                     
                        onFinish={() => {setEdit(!edit); props.onChange()}}                                                    
                        postScheduledId={props.postScheduled.id}
                        scheduledDate={props.postScheduled.scheduledDate}
                    />                  
            }            
            <span style={{ textDecoration: "none", color: "#3C4043", cursor:'pointer', fontWeight: 500, marginLeft:'10px' }} onClick={() => setEdit(!edit)}>
                {(editVisible || edit) && (edit ? <CloseOutlined/> : <EditOutlined />)}
            </span>
        </div>
    )
}
